import { Controller } from "stimulus";

export default class ScrollRevealController extends Controller {
  async connect() {
    if (this.hasTargetValue) {
      this.targetElement = document.querySelector(this.targetValue);
    } else {
      this.targetElement = window;
    }

    this.targetElement.addEventListener("scroll", this.scroll.bind(this));
  }

  scroll() {
    const start = this.startValue;
    const end = this.endValue;
    const scrollY = this.targetElement === window ? window.scrollY : this.targetElement.scrollTop;
    let progress = Math.min(Math.max((scrollY - start) / (end - start), 0), 1);
    this.element.style.opacity = progress;
  }
}

ScrollRevealController.values = {
  start: Number,
  end: Number,
  target: String
}

